import React, { useState, useEffect } from "react";
import TextField from '@material-ui/core/TextField';
import { Autocomplete } from '@material-ui/lab';
import { DataTypeProvider } from "@devexpress/dx-react-grid";
import { http } from "../../services/http";
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    marginTop: theme.spacing(0.4),
  },
  listbox: {
    maxHeight: 300,
    overflow: 'auto',
  },
}));

const CodigoD2iHiaeFormatter = ({ value }) => { 
  const classes = useStyles();
  return (<TextField className={classes.root} value={value || ""} InputProps={{ disableUnderline: true }} />)
};

const CodigoD2iHiaeEditor = ({ value, onValueChange, row, column }) => {
  const [options, setOptions] = useState([]);
  const classes = useStyles();
  const [inputValue, setInputValue] = useState("");
  const [timer, setTimer] = useState(null);
  const [open, setOpen] = useState(false);
  const [initialized, setInitialized] = useState(false);

  // Detecta se está sendo usado no contexto de filtro
  // Filtro: row é null/undefined (contexto de filtro da tabela)
  const isFilterContext = !row;

  // Inicializa o inputValue apenas uma vez quando o componente monta
  useEffect(() => {
    if (!initialized && value) {
      console.log('Inicializando código D2I:', value);
      setInputValue(value);
      setInitialized(true);
    }
  }, [value, initialized]);

  // Escuta mudanças no valor vindo de fora (quando procedimento é selecionado)
  useEffect(() => {
    if (initialized && value && value !== inputValue) {
      console.log('Código D2I atualizado de fora:', value);
      setInputValue(value);
      setOpen(false); // Garante que o dropdown não abre
    }
  }, [value, initialized, inputValue]);

  function searchProcedimentos(searchText) {
    if (searchText.length < 1) {
      setOptions([]);
      setOpen(false);
      return;
    }

    http
      .get(`carga-hiae/procedures/search-by-tuss?search=${searchText}`)
      .then((response) => {
        if (response?.status === 200) {
          const results = response?.data || [];
          setOptions(results);
          setOpen(results.length > 0);
        }
      })
      .catch((error) => {
        console.error("Erro ao buscar códigos D2I:", error);
        setOptions([]);
        setOpen(false);
      });
  }

  function handleInputChange(event, newInputValue) {
    setInputValue(newInputValue);
    onValueChange(newInputValue);

    // Se for contexto de filtro, não faz busca
    if (isFilterContext) {
      return;
    }

    clearTimeout(timer);
    setTimer(
      setTimeout(function () {
        searchProcedimentos(newInputValue);
      }, 300)
    );
  }

  function handleChange(event, newValue) {
    if (newValue && typeof newValue === 'object') {
      // Atualiza o código D2I
      setInputValue(newValue.tuss_code);
      onValueChange(newValue.tuss_code);
      
      // Atualiza o procedimento usando a função global
      if (newValue.name && window.updateRowField) {
        const rowId = row && row.id !== undefined ? row.id : 0;
        console.log('Código D2I selecionado:', { name: newValue.name, tussCode: newValue.tuss_code, rowId });
        
        setTimeout(() => {
          window.updateRowField(rowId, 'procedimento', newValue.name);
        }, 200);
      }
      
      setOpen(false);
    }
  }

  function getOptionLabel(option) {
    if (typeof option === 'string') {
      return option;
    }
    // Mostra: código - nome do procedimento
    if (option?.tuss_code && option?.name) {
      return `${option.tuss_code} - ${option.name}`;
    }
    return option?.tuss_code || "";
  }

  // Se for contexto de filtro, retorna apenas um TextField simples
  if (isFilterContext) {
    return (
      <div className={classes.root}>
        <TextField 
          value={inputValue} 
          onChange={(e) => {
            setInputValue(e.target.value);
            onValueChange(e.target.value);
          }}
          label="" 
          variant="standard" 
          size="small"
        />
      </div>
    );
  }

  return (
    <div className={classes.root}>
      <Autocomplete
        freeSolo
        open={open}
        onOpen={() => {
          if (options.length > 0) setOpen(true);
        }}
        onClose={() => setOpen(false)}
        options={options}
        inputValue={inputValue}
        size="small"
        ListboxProps={{
          className: classes.listbox,
          style: { maxHeight: 300 }
        }}
        getOptionLabel={getOptionLabel}
        onInputChange={handleInputChange}
        onChange={handleChange}
        renderInput={(params) => <TextField {...params} label="" variant="standard" />}
      />
    </div>
  );
};

export const CodigoD2iHiaeTypeProvider = (props) => (
  <DataTypeProvider 
    formatterComponent={CodigoD2iHiaeFormatter} 
    editorComponent={CodigoD2iHiaeEditor} 
    {...props} 
  />
);
